import sports1 from "../../assets/home/sports1.png";
import sports2 from "../../assets/home/sports2.jpg";
import sports3 from "../../assets/home/sports3.jpg";
import sports4 from "../../assets/home/sports4.jpg";

import action1 from "../../assets/home/action1.jpg";
import action2 from "../../assets/home/action2.jpg";
import action3 from "../../assets/home/action3.jpeg";
import action4 from "../../assets/home/action4.jpg";

import fighting1 from "../../assets/home/4a.jpg";
import fighting2 from "../../assets/home/5a.jpg";
import fighting3 from "../../assets/home/6a.jpg";
import fighting4 from "../../assets/home/9a.jpg";

import dota from "../../assets/home/10a.jpg";
import fortnite from "../../assets/home/12a.jpg";
import free_fire from "../../assets/home/1a.jpg";
import fifa_21 from "../../assets/home/2a.jpg";

import league_of_legends from "../../assets/home/14.jpg";
import mk from "../../assets/home/5.jpg";
import street_fighter from "../../assets/home/6.jpg";
import jump_force from "../../assets/home/9.png";

import eightBallPin from "../../assets/home/8ballpin.jpg";
import apex_legends from "../../assets/home/apex_legends.jpeg";
import assasins from "../../assets/home/assasins.jpg";
import brawhalla from "../../assets/home/brawhalla.jpg";

import user1 from "../../assets/home/user1.jpg";
import user2 from "../../assets/home/user2.jpg";
import user3 from "../../assets/home/user3.png";
import user4 from "../../assets/home/user4.png";
import user5 from "../../assets/home/user5.jpg";
import user6 from "../../assets/home/user6.jpeg";
import user7 from "../../assets/home/user7.jpg";
import user8 from "../../assets/home/user8.jpg";

const INITIAL_STATE = {
  homeData: {
    bounty: [
      {
        name: "@val",
        id: "p1o2ie83kjhduw908504ojdofdi1",
        pictureSmall: user1,
        gameName: "Fifa 21",
      },
      {
        name: "@leo",
        id: "p1o2ie83kjhduw908504ojq1nu8y",
        pictureSmall: user2,
        gameName: "Tekken",
      },
      {
        name: "@dan",
        id: "p1o2ie83kjhduw908504ojl9i7ry",
        pictureSmall: user3,
        gameName: "Mortal Kombat",
      },
      {
        name: "@osas",
        id: "p1o2ie83kjhduw908504ojq19o0p",
        pictureSmall: user4,
        gameName: "Call of Duty",
      },
      {
        name: "@emma",
        id: "p1o2ie83kjhduw908504oj2w34ti",
        pictureSmall: user5,
        gameName: "PUGB",
      },
      {
        name: "@chuka",
        id: "p1o2ie83kjhduw908504ojb1di9p",
        pictureSmall: user6,
        gameName: "Street Fighter",
      },
      {
        name: "@uche",
        id: "p1o2ie83kjhduw908504oje4ri90",
        pictureSmall: user7,
        gameName: "DOTA 2",
      },
      {
        name: "@tobi",
        id: "p1o2ie83kjhduw908504ojqp90y8",
        pictureSmall: user8,
        gameName: "Jump Force",
      },
    ],
    categories: [
      {
        id: "wew898erw98797ewr89e",
        category: "action",
        data: [
          { picture: action1, id: "sdsd8989783hiusdf876133212" },
          { picture: action2, id: "sdsd8989783hiusdf876133212" },
          { picture: action3, id: "sdsd8989783hiusdf876133212" },
          { picture: action4, id: "sdsd8989783hiusdf876133212" },
        ],
      },
      {
        id: "wew898erw98797er83jgd",
        category: "sports",
        data: [
          { picture: sports1, id: "sdsd8989783hiusdf876133212" },
          { picture: sports2, id: "sdsd8989783hiusdf876133212" },
          { picture: sports3, id: "sdsd8989783hiusdf876133212" },
          { picture: sports4, id: "sdsd8989783hiusdf876133212" },
        ],
      },
      {
        id: "wew898eg8430rm7ewr89e",
        category: "arcade",
        data: [
          { picture: fighting1, id: "sdsd8989783hiusdf876133212" },
          { picture: fighting2, id: "sdsd8989783hiusdf876133212" },
          { picture: fighting3, id: "sdsd8989783hiusdf876133212" },
          { picture: fighting4, id: "sdsd8989783hiusdf876133212" },
        ],
      },
    ],
    recentlyViewed: [
      {
        creator: ["d3kr0u3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "This is War",
        platformName: "Apex Legends",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Apex Legends",
        category: "Adventure",
        slug: "this-is-war",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: apex_legends,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6t75uie",
      },
      {
        creator: ["x3q4ri3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Brawl Out",
        platformName: "Brawlhalla",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Brawlhalla",
        category: "Adventure",
        slug: "brawl-out",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: brawhalla,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6h4ut1e",
      },
      {
        creator: ["mgj63hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Ballers",
        platformName: "8 Ball Pin",
        devicePlatform: "PS,Xbox,PC",
        gameName: "8 Ball Pin",
        category: "Board Games",
        slug: "ballers",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: eightBallPin,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6vty830i1",
      },
      {
        creator: ["p9ry2thgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "League of Assasins",
        platformName: "Assasins Creed",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Assasins Creed",
        category: "Adventure",
        slug: "league-of-assasins",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: assasins,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6r4u1iu2",
      },
    ],
    oneVOnes: [
      {
        creator: ["mgj63hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Ballers",
        platformName: "8 Ball Pin",
        devicePlatform: "PS,Xbox,PC",
        gameName: "8 Ball Pin",
        category: "Board Games",
        slug: "ballers",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: eightBallPin,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6vty830i1",
      },
      {
        creator: ["p9ry2thgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "League of Assasins",
        platformName: "Assasins Creed",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Assasins Creed",
        category: "Adventure",
        slug: "league-of-assasins",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: assasins,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6r4u1iu2",
      },
      {
        creator: ["d3kr0u3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "This is War",
        platformName: "Apex Legends",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Apex Legends",
        category: "Adventure",
        slug: "this-is-war",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: apex_legends,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6t75uie",
      },
      {
        creator: ["x3q4ri3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Brawl Out",
        platformName: "Brawlhalla",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Brawlhalla",
        category: "Adventure",
        slug: "brawl-out",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: brawhalla,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6h4ut1e",
      },
      {
        creator: ["a0o2e33hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Dota 2 Championship",
        platformName: "Dota",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Dota 2",
        category: "Adventure",
        slug: "dota-2-championship",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: dota,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6o0i9pt",
      },
      {
        creator: ["l0q3pt3hgj3hjgg399823hjh43hjdf87"],
        creatorName: "@leo",
        creatorType: "user",
        name: "Fortnite Alliance",
        platformName: "Fortnite",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fortnite",
        category: "Adventure",
        slug: "fortnite-alliance",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Survive",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fortnite,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6r1t9io",
      },
      {
        creator: ["io2e5t3hgj3hjgg399823453tr98ghj"],
        creatorName: "@dennis",
        creatorType: "user",
        name: "Twitter League",
        platformName: "Fifa",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fifa 21",
        category: "Sports",
        slug: "twitter-league",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Win!!!",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fifa_21,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6v2et8e0wz",
      },
      {
        creator: ["to40pkc0881lioidf35fdioo5646823mvx1"],
        creatorName: "@banner",
        creatorType: "user",
        name: "Lets go to the Gulag!!",
        platformName: "Free Fire",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Free Fire",
        category: "Adventure",
        slug: "lets-go-to-the-gulag!!",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: free_fire,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cno09b1y",
      },
    ],
    featured: [
      {
        creator: ["lo030r3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Dota 2 Championship",
        platformName: "Dota",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Dota 2",
        category: "Adventure",
        slug: "dota-2-championship",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: dota,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6e3tu84",
      },
      {
        creator: ["pu0y4t3hgj3hjgg399823hjh43hjdf87"],
        creatorName: "@leo",
        creatorType: "user",
        name: "Fortnite Alliance",
        platformName: "Fortnite",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fortnite",
        category: "Adventure",
        slug: "fortnite-alliance",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Survive",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fortnite,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6023eiu",
      },
      {
        creator: ["6ip1nt3hgj3hjgg399823453tr98ghj"],
        creatorName: "@dennis",
        creatorType: "user",
        name: "Twitter League",
        platformName: "Fifa",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fifa 21",
        category: "Sports",
        slug: "twitter-league",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Win!!!",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fifa_21,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6v2ee3r47t",
      },
      {
        creator: ["pl1pfkc0881lioidf35fdioo5646823mvx1"],
        creatorName: "@banner",
        creatorType: "user",
        name: "Lets go to the Gulag!!",
        platformName: "Free Fire",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Free Fire",
        category: "Adventure",
        slug: "lets-go-to-the-gulag!!",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: free_fire,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1pwmci",
      },
      {
        creator: ["i0pit5c088143io09p063rjkhkdf46823mvx1"],
        creatorName: "@wayne",
        creatorType: "user",
        name: "Mortal Kombat Immortals Unleashed",
        platformName: "Mortal Kombat",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Mortal Kombat XI",
        category: "Combat",
        slug: "mortal-kombat-immortals-unleashed",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: mk,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn2ebv0p",
      },

      {
        creator: ["k0puirc1m9g64d4x1ipo9u5tjkhkdf46823mvx1"],
        creatorName: "@payne",
        creatorType: "user",
        name: "Hadoken Showdown",
        platformName: "Street Fighter",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Street Fighter V",
        category: "Combat",
        slug: "hadoken-showdown",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: street_fighter,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cni12opl",
      },

      {
        creator: ["h8yi0ox1m9g64d43io09poperjkhkdf46823mvx1"],
        creatorName: "@wade",
        creatorType: "user",
        name: "Jump Force Unleashed",
        platformName: "Jump Force",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Jump Force",
        category: "Combat",
        slug: "jump-force-unleashed",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: jump_force,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1q2z3e0",
      },

      {
        creator: ["h1n5i0c1p0p9e43ac3554iierjkhkdf46823mvx1"],
        creatorName: "@slade",
        creatorType: "user",
        name: "League of Legends Extreme Survival",
        platformName: "League of Legends",
        devicePlatform: "PS,Xbox,PC",
        gameName: "League of Legends",
        category: "Adventure",
        slug: "league-of-legends-extreme-survival",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: league_of_legends,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1l2av9i",
      },
    ],
    challenges: [
      {
        creator: ["mgj63hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Ballers",
        platformName: "8 Ball Pin",
        devicePlatform: "PS,Xbox,PC",
        gameName: "8 Ball Pin",
        category: "Board Games",
        slug: "ballers",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: eightBallPin,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6vty830i1",
      },
      {
        creator: ["p9ry2thgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "League of Assasins",
        platformName: "Assasins Creed",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Assasins Creed",
        category: "Adventure",
        slug: "league-of-assasins",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: assasins,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6r4u1iu2",
      },
      {
        creator: ["d3kr0u3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "This is War",
        platformName: "Apex Legends",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Apex Legends",
        category: "Adventure",
        slug: "this-is-war",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: apex_legends,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6t75uie",
      },
      {
        creator: ["x3q4ri3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Brawl Out",
        platformName: "Brawlhalla",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Brawlhalla",
        category: "Adventure",
        slug: "brawl-out",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: brawhalla,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6h4ut1e",
      },
      {
        creator: ["a0o2e33hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Dota 2 Championship",
        platformName: "Dota",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Dota 2",
        category: "Adventure",
        slug: "dota-2-championship",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: dota,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6o0i9pt",
      },
      {
        creator: ["l0q3pt3hgj3hjgg399823hjh43hjdf87"],
        creatorName: "@leo",
        creatorType: "user",
        name: "Fortnite Alliance",
        platformName: "Fortnite",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fortnite",
        category: "Adventure",
        slug: "fortnite-alliance",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Survive",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fortnite,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6r1t9io",
      },
      {
        creator: ["io2e5t3hgj3hjgg399823453tr98ghj"],
        creatorName: "@dennis",
        creatorType: "user",
        name: "Twitter League",
        platformName: "Fifa",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fifa 21",
        category: "Sports",
        slug: "twitter-league",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Win!!!",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fifa_21,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6v2et8e0wz",
      },
      {
        creator: ["to40pkc0881lioidf35fdioo5646823mvx1"],
        creatorName: "@banner",
        creatorType: "user",
        name: "Lets go to the Gulag!!",
        platformName: "Free Fire",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Free Fire",
        category: "Adventure",
        slug: "lets-go-to-the-gulag!!",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: free_fire,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cno09b1y",
      },
    ],
    tournaments: [
      {
        creator: ["lo030r3hgj3hjgg399823hjhghj"],
        creatorName: "@starq",
        creatorType: "user",
        name: "Dota 2 Championship",
        platformName: "Dota",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Dota 2",
        category: "Adventure",
        slug: "dota-2-championship",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Assasinate all Target",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: dota,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 2,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 2,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 2,
          },
        ],
        numberOfIterations: 2,
        currentIteration: 2,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6e3tu84",
      },
      {
        creator: ["pu0y4t3hgj3hjgg399823hjh43hjdf87"],
        creatorName: "@leo",
        creatorType: "user",
        name: "Fortnite Alliance",
        platformName: "Fortnite",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fortnite",
        category: "Adventure",
        slug: "fortnite-alliance",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Survive",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fortnite,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6023eiu",
      },
      {
        creator: ["6ip1nt3hgj3hjgg399823453tr98ghj"],
        creatorName: "@dennis",
        creatorType: "user",
        name: "Twitter League",
        platformName: "Fifa",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Fifa 21",
        category: "Sports",
        slug: "twitter-league",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Win!!!",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: fifa_21,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87c6v2ee3r47t",
      },
      {
        creator: ["pl1pfkc0881lioidf35fdioo5646823mvx1"],
        creatorName: "@banner",
        creatorType: "user",
        name: "Lets go to the Gulag!!",
        platformName: "Free Fire",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Free Fire",
        category: "Adventure",
        slug: "lets-go-to-the-gulag!!",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: free_fire,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1pwmci",
      },
      {
        creator: ["i0pit5c088143io09p063rjkhkdf46823mvx1"],
        creatorName: "@wayne",
        creatorType: "user",
        name: "Mortal Kombat Immortals Unleashed",
        platformName: "Mortal Kombat",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Mortal Kombat XI",
        category: "Combat",
        slug: "mortal-kombat-immortals-unleashed",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: mk,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn2ebv0p",
      },

      {
        creator: ["k0puirc1m9g64d4x1ipo9u5tjkhkdf46823mvx1"],
        creatorName: "@payne",
        creatorType: "user",
        name: "Hadoken Showdown",
        platformName: "Street Fighter",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Street Fighter V",
        category: "Combat",
        slug: "hadoken-showdown",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: street_fighter,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cni12opl",
      },

      {
        creator: ["h8yi0ox1m9g64d43io09poperjkhkdf46823mvx1"],
        creatorName: "@wade",
        creatorType: "user",
        name: "Jump Force Unleashed",
        platformName: "Jump Force",
        devicePlatform: "PS,Xbox,PC",
        gameName: "Jump Force",
        category: "Combat",
        slug: "jump-force-unleashed",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: jump_force,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1q2z3e0",
      },

      {
        creator: ["h1n5i0c1p0p9e43ac3554iierjkhkdf46823mvx1"],
        creatorName: "@slade",
        creatorType: "user",
        name: "League of Legends Extreme Survival",
        platformName: "League of Legends",
        devicePlatform: "PS,Xbox,PC",
        gameName: "League of Legends",
        category: "Adventure",
        slug: "league-of-legends-extreme-survival",
        //multiple task descriptions for more than one round where a different task is needed
        taskDescription: [
          {
            text: "Rise to the top",
            round: 1,
          },
        ],
        rules: [
          "All Competitions Must Be Subscribed for",
          "Do not participate after elimination",
          "May the best gamer win!!!",
        ],

        free: true,
        subscriptionFee: undefined,
        prizes: undefined,
        pictureCover: league_of_legends,
        pictures: ["", "", "", ""],
        startDate: [
          {
            start: "1631380478459",
            iteration: 1,
          },
        ],
        // duration must be in days
        duration: 10,
        rounds: 1,
        removeForNextRound: 5,
        numberOfPlayers: 10,
        currentlySubscribed: 0,
        full: false,
        numberOfWinners: 2,
        difficulty: 2,
        delayed: false,
        commenced: [
          {
            text: false,
            iteration: 1,
          },
        ],

        ended: [
          {
            text: false,
            iteration: 1,
          },
        ],
        numberOfIterations: 1,
        currentIteration: 1,
        dateCreated: "1631380382031",
        id: "x68cby87xvc87cn1l2av9i",
      },
    ],
  },
};

const homePageDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default homePageDataReducer;
